export enum ROWCOLType {VarRow,StaticRow,VarCol,StaticCol,VarValue,StaticValue};